import { ReactNode, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppSelector } from "../../redux/hooks";
import {
  isAdminAuthCookieSet,
  isClientAuthCookieSet,
  isSalesAuthCookieSet,
} from "../../utils/helpers";

export const Protected = ({ children }: { children: ReactNode }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const { profile, isSignedIn } = useAppSelector((state) => state.auth);

  useEffect(() => {
    const isAuthSet = isClientAuthCookieSet();

    if (!isAuthSet || !isSignedIn) {
      navigate({ pathname: "/login" });
    }
    // eslint-disable-next-line
  }, [location.pathname, profile]);

  return <>{children}</>;
};

export const AdminProtected = ({ children }: { children: ReactNode }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const { adminProfile, isAdminSignedIn } = useAppSelector(
    (state) => state.auth,
  );

  useEffect(() => {
    const isAuthSet = isAdminAuthCookieSet();

    if (!isAuthSet || !isAdminSignedIn) {
      navigate("/login");
    }
    // eslint-disable-next-line
  }, [location.pathname, adminProfile]);

  return <>{children}</>;
};

export const SalesProtected = ({ children }: { children: ReactNode }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const { salesProfile, isSalesSignedIn } = useAppSelector(
    (state) => state.auth,
  );

  useEffect(() => {
    const isAuthSet = isSalesAuthCookieSet();

    if (!isAuthSet || !isSalesSignedIn) {
      navigate("/login");
    }
    // eslint-disable-next-line
  }, [location.pathname, salesProfile]);

  return <>{children}</>;
};
